import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav } from 'react-bootstrap';

const Header = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="fixed-top">
      {/* Topbar */}
      <div className="topbar d-none d-lg-block">
        <Container>
          <div className="topbar-inner">
            <div className="row gx-0">
              <div className="col-lg-7 text-start">
                <div className="h-100 d-inline-flex align-items-center me-4">
                  <span className="fa fa-phone-alt me-2 text-dark"></span>
                  <a href="tel:+1234567890" className="text-secondary">
                    <span>+1 (234) 567-8900</span>
                  </a>
                </div>
                <div className="h-100 d-inline-flex align-items-center">
                  <span className="far fa-envelope me-2 text-dark"></span>
                  <a href="mailto:info@harveymasjid.org" className="text-secondary">
                    <span>info@harveymasjid.com</span>
                  </a>
                </div>
              </div>
              <div className="col-lg-5 text-end">
                <div className="h-100 d-inline-flex align-items-center">
                  <span className="text-body">Follow Us:</span>
                  <a className="text-dark px-2" href="https://facebook.com/harveymasjid" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a className="text-dark px-2" href="https://twitter.com/harveymasjid" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a className="text-dark px-2" href="https://instagram.com/harveymasjid" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a className="text-dark px-2" href="https://www.youtube.com/@ssicharveymasjid7160" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Navbar */}
      <Container>
        <Navbar expand="lg" className="navbar-light py-3" expanded={expanded}>
          <Link to="/" className="navbar-brand" onClick={() => setExpanded(false)}>
            <h1 className="mb-0">Harvey<span className="text-primary">Masjid</span></h1>
          </Link>
          <Navbar.Toggle 
            aria-controls="navbarCollapse" 
            onClick={() => setExpanded(expanded ? false : true)}
          >
            <span className="fa fa-bars text-primary"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarCollapse" className="bg-white">
            <Nav className="ms-lg-auto mx-xl-auto">
              <Link to="/" className="nav-link" onClick={() => setExpanded(false)}>Home</Link>
              <Link to="/about" className="nav-link" onClick={() => setExpanded(false)}>About</Link>
              {/* <Link to="/events" className="nav-link" onClick={() => setExpanded(false)}>Events</Link> */}
              <Link to="/contact" className="nav-link" onClick={() => setExpanded(false)}>Contact</Link>
            </Nav>
            <Link to="/donate" className="btn btn-primary py-2 px-4 d-none d-xl-inline-block" onClick={() => setExpanded(false)}>
              Donate
            </Link>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
};

export default Header;